module.exports = __webpack_public_path__ + "img/cc_5_star.bc31d4ed.png";